/**
 * @module lib/selector
 * @description A collection of functions for selecting elements within the document.
 *
 * @example
 * import { e, ee } from './lib/selector.js';
 * const element = e('.selector');
 * const elements = ee('.selector');
 *
 * @version 1.0.0
 * @since 1.0.0
 *
 * @exports e
 * @exports ee
 */

/**
 * Selects the first element within the document that matches the specified selector.
 *
 * @param {string} selector - A string containing one or more CSS selectors to match.
 * @param {Document|Element} [root=document] - An optional parameter specifying the root element to start the search from. Defaults to the document.
 * @returns {Element|null} The first element within the document that matches the specified selector, or null if no matches are found.
 */

export const e = (selector, root = document) => root.querySelector(selector);

/**
 * Selects all elements that match the specified CSS selector within the given root element.
 *
 * @param {string} selector - The CSS selector to match elements against.
 * @param {Document|Element} [root=document] - The root element to start the search from. Defaults to the document.
 * @returns {NodeList} A NodeList of elements that match the specified selector.
 */

export const ee = (selector, root = document) =>
    root.querySelectorAll(selector);
